/** @format */

import React, { useMemo, useState } from 'react';
import { useQuery, useMutation } from '@apollo/client';

import { GROUPS } from '../../../../apollo/query/Group';
import { ALL_ASSETS_MEM_ID } from '../../../../apollo/query/AssetQuery';
import { CARD_ACTION } from '../../../../apollo/mutation/CardMutation';

import AssetCard from '../AssetCard/AssetCard';

const GroupCard = (group, index, handleOpen, active) => {
  return (
    <li className="group-card" key={index + group.name}>
      <div
        className={`group-card__header-container${active ? ' group-card__header-container--trigged' : ''}`}
        onClick={() => handleOpen(index)}
      >
        <div className="group-card__name">{group.name}</div>
      </div>
    </li>
  );
};

const Group = ({ cards }) => {
  const { data: groupData, loading: groupLoading } = useQuery(GROUPS);
  const { data: assetData, loading: assetLoading } = useQuery(ALL_ASSETS_MEM_ID);
  const [mutateMarkerVisible] = useMutation(CARD_ACTION);

  const [openedGroup, setOpenedGroup] = useState(-1);

  const groupsWithAssets = useMemo(() => {
    if (!groupData || !assetData) return [];

    const groups = [...groupData.groups];

    const assetsWithoutGroup = assetData.assetsInMem.filter(asset => {
      return !groupData.groups.some(group => group.assets.includes(asset.id));
    });

    groups.push({
      name: 'nezařazeno',
      assets: assetsWithoutGroup.map(x => x.id),
    });

    return groups;
  }, [groupData, assetData]);

  const handleOpen = (index) => {
    if (openedGroup === index) {
      setOpenedGroup(-1);
      return;
    }

    setOpenedGroup(index);

    // okamžité spuštění mutací
    const selectedGroup = groupsWithAssets[index];
    const activeAssets = assetData.assetsInMem.filter(asset =>
      selectedGroup.assets.includes(asset.id)
    );

    activeAssets.forEach(asset => {
      mutateMarkerVisible({
        variables: {
          id: asset.id,
          action: 'checkBoxClicked',
        },
      });
    });
  };

  if (groupLoading || assetLoading) return null;

  return (
    <ul className="group-list">
      {groupsWithAssets.map((group, index) => {
        const isActive = index === openedGroup;
        return (
          <React.Fragment key={group.name + index}>
            {GroupCard(group, index, handleOpen, isActive)}
            {isActive &&
              assetData.assetsInMem
                .filter(asset => group.assets.includes(asset.id))
                .map(asset => <AssetCard key={asset.id} assetId={asset.id} />)}
          </React.Fragment>
        );
      })}
    </ul>
  );
};

export default Group;